import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
const CHECKOUT_URL = 'https://tucambioclave.com/cart/45310250811439:1';
export function Button({
  children,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
      return;
    }
    window.location.href = CHECKOUT_URL;
  };
  return <motion.button whileHover={{
    scale: 1.02,
    y: -2
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`bg-heritage-terracotta text-white font-serif font-semibold text-lg md:text-xl px-8 py-4 rounded-md shadow-md hover:shadow-lg transition-shadow duration-300 w-full md:w-auto ${className}`} {...props} data-id="element-163">
      {children}
    </motion.button>;
}